import { Card, CardContent } from '../ui/card';
import { Target, TrendingUp, Users, Tag } from 'lucide-react';
import { type CampaignStats } from './types';

interface CampaignStatsCardsProps {
    stats: CampaignStats;
}

export function CampaignStatsCards({ stats }: CampaignStatsCardsProps) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Card className="p-4">
 <CardContent className="p-0">
                    <div className="flex items-center justify-between">
 <div>
   <p className="text-sm text-gray-600 mb-1">Total Campaigns</p>
       <p className="text-2xl font-semibold">{stats.totalCampaigns}</p>
 </div>
     <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
    <Target className="w-4 h-4 text-blue-600" />
      </div>
     </div>
                </CardContent>
         </Card>

            <Card className="p-4">
                <CardContent className="p-0">
     <div className="flex items-center justify-between">
         <div>
           <p className="text-sm text-gray-600 mb-1">Active Campaigns</p>
 <p className="text-2xl font-semibold">{stats.activeCampaigns}</p>
       </div>
     <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
      <TrendingUp className="w-4 h-4 text-green-600" />
         </div>
    </div>
      </CardContent>
        </Card>

     <Card className="p-4">
      <CardContent className="p-0">
         <div className="flex items-center justify-between">
            <div>
<p className="text-sm text-gray-600 mb-1">Business Units</p>
      <p className="text-2xl font-semibold">{stats.businessUnits}</p>
        </div>
     <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
          <Users className="w-4 h-4 text-purple-600" />
 </div>
     </div>
         </CardContent>
        </Card>

         <Card className="p-4">
   <CardContent className="p-0">
          <div className="flex items-center justify-between">
     <div>
       <p className="text-sm text-gray-600 mb-1">Categories</p>
        <p className="text-2xl font-semibold">{stats.categories}</p>
              </div>
       <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
 <Tag className="w-4 h-4 text-orange-600" />
        </div>
                  </div>
       </CardContent>
      </Card>
        </div>
    );
}
